import { render } from "./ModuleFacetFilters.vue?vue&type=template&id=2abf6000&scoped=true"
import script from "./ModuleFacetFilters.vue?vue&type=script&lang=js"
export * from "./ModuleFacetFilters.vue?vue&type=script&lang=js"

import "./ModuleFacetFilters.vue?vue&type=style&index=0&id=2abf6000&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2abf6000"]])

export default __exports__